export default __webpack_public_path__ + "2bde6b0f336b0fee9a31e4b8f3ec7579.ttf";